var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"mobile-center",attrs:{"md":"12","lg":"12","xl":"5"}},[_c('Intro'),_c('Media'),_c('Followers'),_c('HotBusiness',{staticClass:"mb-md-3"})],1),_c('b-col',{staticClass:"pt-0 mt-0",attrs:{"md":"12","lg":"12","xl":"7"}},[_c('Post')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }